import { useAffiliateStore } from '@/stores/affiliateStore'

/**
 * Extract affiliate code from URL parameters
 */
export function extractAffiliateCodeFromUrl(): string | null {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get('ref')
}

/**
 * Store affiliate code in localStorage for attribution
 */
export function storeAffiliateCode(code: string): void {
  localStorage.setItem('affiliate_code', code)
  localStorage.setItem('affiliate_first_visit', new Date().toISOString())
}

/**
 * Get stored affiliate code from localStorage
 */
export function getStoredAffiliateCode(): string | null {
  return localStorage.getItem('affiliate_code')
}

/**
 * Generate a full affiliate URL with the provided code
 */
export function generateAffiliateUrl(code: string, targetUrl = window.location.origin): string {
  const url = new URL(targetUrl)
  url.searchParams.set('ref', code)
  return url.toString()
}

/**
 * Track affiliate click if code is present in URL
 */
export async function trackAffiliateVisit(): Promise<void> {
  const code = extractAffiliateCodeFromUrl()

  if (code) {
    // Store for later attribution
    storeAffiliateCode(code)

    // Track the click
    const affiliateStore = useAffiliateStore()
    await affiliateStore.trackClick(code)
    // Redirect to the homepage
    const currentUrl = window.location.href
    const isSharedPage = currentUrl.includes('https://app.meetinghero.ai/shared/')

    if (isSharedPage) {
      // Remove the ref parameter from the URL without redirecting
      const url = new URL(window.location.href)
      url.searchParams.delete('ref')
      window.history.replaceState({}, document.title, url.toString())
    } else {
      // Redirect to homepage if not a shared page
      window.location.href = 'https://meetinghero.ai'
    }
  }
}

/**
 * Copy affiliate link to clipboard
 */
export async function copyAffiliateLink(code: string): Promise<boolean> {
  try {
    const fullUrl = generateAffiliateUrl(code)
    await navigator.clipboard.writeText(fullUrl)
    return true
  } catch (err) {
    console.error('Failed to copy link to clipboard', err)
    return false
  }
}
